// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info[data-v-f21f1628] {\n  padding-top: 20px;\n  padding-bottom: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
